import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'xui-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule]
})
export class ConfirmationDialogComponent implements OnInit {

  private dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);
  private data = inject<DialogData>(MAT_DIALOG_DATA);

  confirmTitle: string = this.data.title ?? 'Please Confirm';
  confirmMessage: string = this.data.message ?? 'Are you sure?';

  ngOnInit(): void {
  }

  onClick(action: boolean) {
    this.dialogRef.close(action);
  }
}

export interface DialogData {
  title: string;
  message: string;
}
